export const SET_SELECTED_EXPERIENCE = 'SET_SELECTED_EXPERIENCE';
export const CLEAR_SELECTED_EXPERIENCE = 'CLEAR_SELECTED_EXPERIENCE';
export const SET_EXPERIENCE_COMMENT = "SET_EXPERIENCE_COMMENT";
export const SET_OPTION_FEEDBACK = "SET_OPTION_FEEDBACK";
export const SET_SELECTED_LOCATION = 'SET_SELECTED_LOCATION';
export const CLEAR_SELECTED_LOCATION = 'CLEAR_SELECTED_LOCATION';


// Action to set selected experience for an option
export const setSelectedExperience = (option, experience) => ({
  type: SET_SELECTED_EXPERIENCE,
  payload: { option, experience },
});

// Action to clear selected experience
export const clearSelectedExperience = () => ({
  type: CLEAR_SELECTED_EXPERIENCE,
});

// Action to set the comment for an experience option
export const setExperienceComment = (option, comment) => ({ 
  type: SET_EXPERIENCE_COMMENT,
  payload: { option, comment },
});

export const setOptionFeedback = (option, experience, comment) => ({
  type: SET_OPTION_FEEDBACK,
  payload: { option, experience, comment },
});

export const setSelectedLocation = (location) => ({
  type: SET_SELECTED_LOCATION,
  payload: location,
});

export const clearSelectedLocation = () => ({
  type: CLEAR_SELECTED_LOCATION,
});
